'use strict';

var _ = require('underscore');
var $ = require('js/sw-jquery/sw-jquery');

/**
 * A view builder which instantiates http://idangero.us/swiper
 * 
 * @param $fragment
 */
module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-swiper]').each(function() {
    var $el = $(this);
    var $activeSlide = $el.find('[data-sw-swiper-active-slide]');

    /**
     * All options can be found at http://idangero.us/swiper/api/#parameters
     * any option found in idangero.us need to be prefixed with data-sw-swiper
     * and be in kabab case on the element
     */

    var options = $el.swDataParams('swSwiper', { excludePrefix: true });

    // data-sw-swiper-active-slide takes prio over initalSlide set on root
    if($activeSlide.length) {
      options.initialSlide = $activeSlide.index();
    }

    $el.swSwiper(_.extend({
      nextButton: $el.find('[data-sw-swiper-next]')[0],
      prevButton: $el.find('[data-sw-swiper-prev]')[0]
    }, options));

  });

};
